/**
 * The bounds the api's client-error ingest enforces, restated here ONCE so the browser never sends a
 * report the server will refuse (kitecorp/transferify-api-service#2644, kitecorp/transferify-ui#2581).
 *
 * These are the api's numbers, not ours. `clientErrorLimits.contract.test.ts` reads them off the api
 * checkout and fails on any difference, in either direction — the idiom
 * `contracts/contractCancellationLimits.contract.test.ts` uses, and for the same reason. A ui bound that is
 * LOOSER lets a report through to a 400, which on this endpoint is the worst possible outcome: the one
 * report that would have said the app is broken is the one that is thrown away. A ui bound that is TIGHTER
 * silently cuts a diagnostic the server would have kept.
 *
 * React-free by mandate (`logic-outside-react`): every rule about WHAT to send lives in this directory, and
 * the boundaries only decide when.
 */

/** The api's `ClientErrorText.MESSAGE_MAX_LENGTH`. */
export const CLIENT_ERROR_MESSAGE_MAX_LENGTH = 300;

/** The api's `ClientErrorText.FRAME_MAX_LENGTH`. */
export const CLIENT_ERROR_FRAME_MAX_LENGTH = 200;

/** The api's `ClientErrorReportRequest.NAME_MAX_LENGTH`. */
export const CLIENT_ERROR_NAME_MAX_LENGTH = 64;

/** The api's `ClientErrorReportRequest.MAX_FRAMES` — the first two frames ui#2581 asks for. */
export const CLIENT_ERROR_MAX_FRAMES = 2;

/** The api's `ClientErrorReportRequest.ROUTE_MAX_LENGTH`. */
export const CLIENT_ERROR_ROUTE_MAX_LENGTH = 128;

/** The api's `ClientErrorReportRequest.MAX_ABSORBED_COUNT`. */
export const CLIENT_ERROR_MAX_ABSORBED_COUNT = 100_000;
